// @flow
import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import {usePrefs} from 'docs/data';
import type {Server} from 'docs/data/integration-builder';
import {Setting} from './Setting';

const messages = defineMessages({
  backend: {
    id: 'docsApp.integrationBuilder.settings.backend',
    description: 'Backend label',
    defaultMessage: 'Backend:',
  },
});

type ServerSettingProps = {|
  servers: Array<Server>,
|};

export const ServerSetting = ({servers}: ServerSettingProps) => {
  const {getPref, setPref} = usePrefs();
  const serverPref = getPref('lang');
  const server =
    serverPref && servers.includes(serverPref) ? serverPref : servers[0];
  if (!servers.includes(serverPref)) {
    setPref('lang', servers[0]);
  }

  if (servers.length < 2) {
    return null;
  }

  return (
    <Setting
      label={<FormattedMessage {...messages.backend} />}
      pref="lang"
      activeItem={server}
      items={servers}
    />
  );
};
